import type { SliceComponentProps } from "@commercekit/prismic";
import React from "react";
import type { PhotoCarouselWithRichTextSlice } from "~/lib/prismic/types.generated";
import DefaultPhotoCarouselWithRichText from "./variations/defaultCarousel";
import TwoColumnPhotoCarouselWithRichText from "./variations/twoColumnCarousel";

const PhotoCarouselWithRichText = ({
  slice,
}: SliceComponentProps<PhotoCarouselWithRichTextSlice>) => {
  switch (slice.variation) {
    case "default": {
      return <DefaultPhotoCarouselWithRichText slice={slice} />;
    }
    case "twoColumn": {
      return <TwoColumnPhotoCarouselWithRichText slice={slice} />;
    }
    default:
      return <div className="hidden">Content</div>;
  }
};


export default PhotoCarouselWithRichText;
